import SectionMessage from "@atlaskit/section-message";
import axios from "axios";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SupportLoader from "../common/SupportLoader";
import CommonValues from "../common/utils";

interface ChatResponse {
  conversationId: string;
  companyId: number;
  response: string;
  sources: string[];
  imageURLs: string[];
  videoURLs: string[];
  imageSidebar: boolean;
  question: string;
  chatId: string;
  like: boolean;
  disLike: boolean;
  feedback: string;
  showFeedback: boolean;
  feedbackLoading: boolean;
  plotlyData: { data: string; layout: string };
  textToAction: string;
  responseStreaming: boolean;
  ai_tool: string;
  insured_id: string;
  policy_id: string;
}

interface UploadFileResponse {
  fileURL: string;
  fileName: string;
}

export default function AcordCOIDownloadPage() {
  const [question, setQuestion] = useState("");
  const [questionLoading, setQuestionLoading] = useState(false);
  const [chatResponses, setChatResponses] = useState<ChatResponse[]>([]);
  const [uploadFileResponses, setUploadFileResponses] = useState<
    UploadFileResponse[]
  >([]);
  const [uploadFile, setUploadFile] = useState<File[]>([]);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [chatBotEmbeded, setChatBotEmbeded] = useState(true);
  const [avatarName, setAvatarName] = useState<string | null>("");
  const [firstFileURL, setFirstFileURL] = useState("");
  const [secondFileURL, setSecondtFileURL] = useState("");
  const [transcribingAudio, setTranscribingAudio] = useState(false);
  const [recordingAudio, setRecordingAudio] = useState(false);
  const [audioRecorder, setAudioRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [conversationLoading, setConversationLoading] = useState(false);
  const [uploadFileToBlobLoading, setUploadFileToBlobLoading] = useState(false);
  const [latestQuestion, setLatestQuestion] = useState({});
  const [dragOver, setDragOver] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [downloadAcordCOIErrorMessage, setDownloadAcordCOIErrorMessage] =
    useState("");
  const [downloadAcordCOISuccessMessage, setDownloadAcordCOISuccessMessage] =
    useState("");
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const toast: any = useRef("");
  const navigate = useNavigate();

  const suggestedQuestions = [
    {
      title: "Driving License Scan",
      description:
        "Captures data from PDF/IMAGE and converts it into smart forms.",
      question:
        "I want to scan driving license and add a driver to the AMS. Can you help me with that?",
    },
    {
      title: "Invoice Scan",
      description:
        "Captures data from invoices and creates endorsements in AMS.",
      question:
        "I want to scan invoice PDF and import billing endorsement in AMS.",
    },
    {
      title: "Commission Scan",
      description: "Captures data from PDF and extracts data.",
      question:
        "I want to scan commission PDF and import commissions statement in AMS.",
    },
    {
      title: "Policy Summarize",
      description: "Upload your policy document and summarize it.",
      question: "I want to create summary of this policy dec page",
    },
    {
      title: "Policy Compare",
      description: "Upload your policy documents and compare them.",
      question: "I want to compare these two policy dec pages",
    },
    {
      title: "Acord Scan",
      description:
        "Upload your Acord forms and declaration pages to create insured and prospect information.",
      question: "I want to scan acord and dec pages.",
    },
  ];

  useEffect(() => {
    let token = CommonValues.GetToken();
    if (token == "" || token == null) {
      CommonValues.Logout(navigate);
    }
    localStorage.setItem("Embeded", String(chatBotEmbeded));

    setChatBotEmbeded(localStorage.getItem("Embeded") === "true");
    downloadAcordCOI(window.location.href.split("/")[4]);
    setUploadFile([]);
    setUploadFileResponses([]);
    setQuestion("");
    setAvatarName(localStorage.getItem("AvatarName"));
  }, [window.location.href.split("/")[4]]);

  const downloadAcordCOI = (conversationId: string | null) => {
    if (
      conversationId === undefined ||
      conversationId === null ||
      conversationId === ""
    ) {
      return;
    }
    setConversationLoading(true);
    const token = CommonValues.GetToken();

    const config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/ncmomentumgpt/acord-coi/${conversationId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.data.acordCOIUrl !== "") {
          window.open(response.data.acordCOIUrl, "_self");
          setDownloadAcordCOISuccessMessage(
            "Acord COI is downloaded successfully!"
          );
        } else {
          setDownloadAcordCOIErrorMessage(
            "Acord COI is not available. Please try again!"
          );
        }

        setConversationLoading(false);
      })
      .catch((error: any) => {
        setConversationLoading(false);
        if (error.response.status == 401) {
          CommonValues.Logout(navigate);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Unknown error while getting conversation history",
            life: 3000,
          });
        }
      });
  };

  return (
    <div className="ai-support-main-page">
      <Toast ref={toast} />

      <div className="ai-wrapper min-vh-100">
        <div className="ai-wrapper-container  position-relative z-1">
          <div className="row g-4 mx-auto">
            <div
              className="col-2 px-0 border-end"
              style={{ paddingTop: "2%" }}
            ></div>
            <div className="col-10 px-0" style={{ paddingTop: "2%" }}>
              <div className="container p-3 d-flex flex-column h-100">
                <div className="ai-main-content-wrapper" ref={chatContainerRef}>
                  <div className="mt-5 text-center">
                    <h4>Download Acord COI</h4>
                  </div>
                  {conversationLoading ? (
                    <div className="col chat-bot-response-area-loader-placeholder d-flex justify-content-center align-items-center">
                      <div className="d-flex justify-content-center">
                        <SupportLoader />
                      </div>
                    </div>
                  ) : (
                    <div className="mt-4 row">
                      <div className="col-md-4"></div>
                      <div className="col-md-4">
                        {downloadAcordCOIErrorMessage !== "" && (
                          <SectionMessage appearance="information">
                            <p>
                              <span className="d-block text-14 text-dark">
                                {downloadAcordCOIErrorMessage}
                              </span>
                            </p>
                          </SectionMessage>
                        )}
                        {downloadAcordCOISuccessMessage !== "" && (
                          <SectionMessage appearance="success">
                            <p>
                              <span className="d-block text-14 text-dark">
                                {downloadAcordCOISuccessMessage}
                              </span>
                            </p>
                          </SectionMessage>
                        )}
                      </div>
                      <div className="col-md-4"></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
